import { equipmentTemplateConstants } from '../EquipmentTemplate/equipmentTemplate.constants'

const initialState = {
  equipmentTemplatesForClient: [],
  equipmentTemplatesForClients: [],
  equipmentTemplateForEditing: null,
  calendarServicesForEquipmentTemplate: {},
  loadingCalendarServicesForEquipmentTemplate: false,

  deletingEquipmentTemplate: false,
  loading: false,
  savingDuplicate: false,
  error: null,
}

export function equipmentTemplates(state = initialState, action) {
  switch (action.type) {
    case equipmentTemplateConstants.REQUEST_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case equipmentTemplateConstants.REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    case equipmentTemplateConstants.FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENTS:
      return {
        ...state,
        loading: false,
        equipmentTemplatesForClients: {
          ...state.equipmentTemplatesForClients,
          [action.clientId]: action.equipmentTemplates,
        },
      }
    case equipmentTemplateConstants.FETCH_EQUIPMENT_TEMPLATE_DOCUMENTS: {
      const updatedEquipmentWithDocuments = state.equipmentTemplatesForClients.map(item => {
        if (item.clientId !== action.clientId) {
          return item
        }
        item.documents = action.equipmentDocuments
        return item
      })
      return {
        ...state,
        equipmentsForBoat: updatedEquipmentWithDocuments,
        loading: false,
      }
    }
    case equipmentTemplateConstants.FETCH_EQUIPMENT_TEMPLATES_FOR_CLIENT:
      return {
        ...state,
        equipmentTemplatesForClient: action.equipmentTemplates,
        loading: false,
      }
    case equipmentTemplateConstants.SET_EQUIPMENT_TEMPLATE_FOR_EDITING:
      return {
        ...state,
        equipmentTemplateForEditing: action.equipmentTemplateForEditing,
      }
    case equipmentTemplateConstants.FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE:
      return {
        ...state,
        loading: true,
      }
    case equipmentTemplateConstants.FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        equipmentTemplateForEditing: {
          ...state.equipmentTemplateForEditing,
          details: action.details,
        },
      }
    case equipmentTemplateConstants.FETCH_DETAILS_FOR_EQUIPMENT_TEMPLATE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    case equipmentTemplateConstants.FETCH_SERVICES_FOR_EQUIPMENT_TEMPLATE:
      return {
        ...state,
        loadingCalendarServicesForEquipmentTemplate: false,
        calendarServicesForEquipmentTemplate: {
          ...state.calendarServicesForEquipmentTemplate,
          [action.equipmentId]: {
            ...state.calendarServicesForEquipmentTemplate[action.equipmentId],
            [action.serviceType]: action.services,
          },
        },
        loading: false,
      }
    case equipmentTemplateConstants.DELETE_EQUIPMENT_TEMPLATE:
      return {
        ...state,
        deletingEquipmentTemplate: true,
      }
    case equipmentTemplateConstants.DELETE_EQUIPMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        deletingEquipmentTemplate: false,
      }
    case equipmentTemplateConstants.DELETE_EQUIPMENT_TEMPLATE_ERROR:
      return {
        ...state,
        deletingEquipmentTemplate: false,
      }
    case equipmentTemplateConstants.DUPLICATE_REQUEST_START:
      return {
        ...state,
        savingDuplicate: true,
      }
    case equipmentTemplateConstants.DUPLICATE_REQUEST_STOP:
      return {
        ...state,
        savingDuplicate: false,
      }
    case equipmentTemplateConstants.DUPLICATE_REQUEST_ERROR:
      return {
        ...state,
        savingDuplicate: false,
      }
    default:
      return state
  }
}
